import React from "react";

const LENS =
  "M22 44 C22 22 56 14 100 14 C144 14 178 22 178 44 C178 84 146 106 100 106 C54 106 22 84 22 44 Z";
const STROKE = "#1579b0";

const LensIllustration = ({ type }) => {
  const clipId = `qz-clip-${type}`;
  const gradId = `qz-grad-${type}`;

  return (
    <svg viewBox="0 0 200 120" aria-hidden="true" focusable="false">
      <defs>
        <clipPath id={clipId}>
          <path d={LENS} />
        </clipPath>
        <linearGradient id={gradId} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#e3f6fe" />
          <stop offset="1" stopColor={type === "progressive" ? "#87d3f6" : "#bfe9fb"} />
        </linearGradient>
      </defs>

      {type === "none" ? (
        <g fill="none" stroke="#8fb4cb" strokeWidth="2.5" strokeLinecap="round">
          <path d={LENS} strokeDasharray="7 7" />
          <path d="M52 96 L148 24" />
        </g>
      ) : (
        <>
          <path d={LENS} fill={`url(#${gradId})`} />

          <g clipPath={`url(#${clipId})`}>
            {/* Bifocal: a visible reading segment in the lower half */}
            {type === "bifocal" && (
              <path
                d="M68 68 H132 A32 32 0 0 1 68 68 Z"
                fill="#ffffff"
                fillOpacity="0.55"
                stroke={STROKE}
                strokeWidth="2"
              />
            )}

            {/* Progressive: a smooth corridor with no visible line */}
            {type === "progressive" && (
              <path
                d="M70 22 H130 L113 62 L124 104 H76 L87 62 Z"
                fill="#ffffff"
                fillOpacity="0.45"
              />
            )}

            {/* Glare */}
            <path
              d="M46 44 Q60 28 92 24"
              fill="none"
              stroke="#ffffff"
              strokeWidth="5"
              strokeLinecap="round"
              opacity="0.8"
            />
          </g>

          <path d={LENS} fill="none" stroke={STROKE} strokeWidth="2.5" />
        </>
      )}
    </svg>
  );
};

export default LensIllustration;